module.exports = __webpack_public_path__ + "static/img/icons_sales_agent_invoices_blue.1846881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_sales_agent_invoices_blue.svg
// module id = QSxF
// module chunks = 1